import AccountGiftCards from './AccountGiftCards'

export default AccountGiftCards
